<template>
  <div v-if="isLoading" class="flex justify-center items-center py-20">
    <div
      class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primaryDarkBg"
    ></div>
  </div>  
    <div v-else-if=" !isLoading" class="m8 my-6">
<div
        class="mx-auto w-[400px] border border-grayLight rounded-full align-center py-2 px-8 mb-8 flex items-center justify-between bg-white-to-gray"
      >
        <div class="flex space-x-2 items-center">
          <h1 class="text-[20px] text-bodyText font-bold">
            ${{ totalAmountInvested }}
          </h1>
          <h1 class="text-[14px] text-grayDark">Total Amount Invested</h1>
        </div>
        <div class="h-8 w-[1px] bg-grayLight"></div>

        <div class="flex space-x-2 items-center">
          <h1 class="text-[20px] text-bodyText font-bold">
            {{ projectsToShow.length }}
          </h1>
          <h1 class="text-[14px] text-grayDark">Joined Projects</h1>
        </div>
      </div>


      <!-- No projects state -->
      <div
        v-if="projectsToShow.length === 0"
        class="flex flex-col items-center justify-center py-20 text-center"
      >
        <p class="text-gray-600 text-lg font-medium">No projects found</p>
        <p class="text-gray-500 mt-1">You're yet to invest in a project.</p>
        <p
          @click="goToProjects"
          class="mt-6 px-4 py-2 border border-grayLight text-grayDark rounded-md hover:bg-opacity-90 transition-colors cursor-pointer"
        >
          Join a Project Now to Invest.
        </p>
      </div>

      <div
        v-else
        class="px- space-y-4 py-6 rounded-lg"
      >
        <p>Projects</p>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div
            v-for="project in projectsToShow"
            :key="project.project_id"
            @click="goToProject(project.project_id)"
            class="w-full md:w-[315px] h-[176px] border border-grayLight rounded-lg py-3 px-3 space-y-4 mb-4 flex flex-col justify-between items-start cursor-pointer bg-white-to-gray"
          >
            <div class="flex justify-between w-full items-center">
              <div class="flex gap-2">
                <img
                  :src="project.logo || project.cover_image || require('@/assets/projects/default_logo.png')"
                  alt="team"
                  class="w-8 h-8 overlap rounded-full object-cover"
                />
                <h2
                  class="w-[140px] truncate text-[16px] text-bodyText font-semibold"
                >
                  {{ project.project_name }}
                </h2>
              </div>
              <div
                class="flex py-[6px] px-2 rounded-full bg-[#E5FAE7] space-x-2 items-center"
              >
                <p class="text-[13px] text-[#2FA81F]">
                  ₦{{ project.total_invested.toLocaleString() || 0 }}
                </p>
              </div>
            </div>
            <p class="text-[10px] font-medium text-grayDark">
              {{ project.description }}
            </p>

            <div class="w-full">
              <p class="text-[11px] font-semibold text-bodyText mb-2">
                Progress
              </p>
              <div class="flex items-center">
                <div
                  class="relative w-[100%] h-[9px] bg-[#F3F4F6] rounded-full overflow-hidden"
                >
                  <div
                    class="absolute top-0 left-0 h-full bg-primaryDark rounded-full"
                    :style="{ width: `${project.progress || 0}%` }"
                  ></div>
                </div>
                <span class="ml-2 text-[12px] font-medium">
                  {{ project.progress || 0 }}%
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "InvestorProjects",
  components: {},
  props: {
    projects: {
      type: Array,
      default: () => []
    },
    joinedProjects: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    // totalAmountInvested: {
    //   type: [Number, String],
    //   default: 0
    // }
  },
  data() {
    return {};
  },
  computed: {
    isInvestor() {
      return this.$store.getters.isInvestor;
    },
    joinedProjectsCount() {
      return Array.isArray(this.joinedProjects) ? this.joinedProjects.length : 0;
    },
    projectsToShow() {
      if (Array.isArray(this.joinedProjects) && this.joinedProjects.length) {
        return this.joinedProjects;
      }
      return Array.isArray(this.projects) ? this.projects : [];
    },
    totalAmountInvested() {
      return this.joinedProjects.reduce((total, project) => {
        return total + (project.total_invested || 0);
      }, 0);
    }
  },
  methods: {
    goToProject(projectId) {
      this.$router.push({ name: "ProjectDetails", params: { projectId } });
    },
    goToProjects() {
      // Add your navigation logic here
      this.$router.push({ name: "Projects" });
    }
  },
  mounted() {
    // You can add any mounted logic here if needed
    console.log("InvestorProjects component mounted.", this.projects);
    console.log("Joined Projects:", this.joinedProjects);
    console.log("Total Amount Invested:", this.totalAmountInvested);
    console.log("Is Investor:", this.isInvestor);
    console.log("Projects to Show:", this.projectsToShow);
  },
};
</script>